import React from 'react';

export const InsertImage = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 7C1 4.79086 2.79086 3 5 3H19C21.2091 3 23 4.79086 23 7V17C23 19.2091 21.2091 21 19 21H5C2.79086 21 1 19.2091 1 17V7Z"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      d="M1 14.5L5.1257 9.54916C5.55863 9.02965 6.37165 9.0807 6.73619 9.6503L14 21"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      d="M11 16L13.6725 12.9457C14.0959 12.4618 14.8593 12.4975 15.2358 13.0187L21 21"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      d="M18.2817 17C19.346 15.9383 20 14.0877 20 12.5C20 9.2365 17.5 6.5 13.5 6.5C10 6.5 8.34153 8.69477 7.5 11"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);
